import { type FC } from "react";
import { Helmet } from "react-helmet-async";

interface SeoProps {
  title?: string;
  preConfig?: "login" | "register";
  metaDescription?: string;
  metaKeywords?: string;
}

const DEFAULT_META_DESCRIPTION = `Buy and sell Bitcoin (BTC), Ethereum (ETH) and other digital assets on Archax, a regulated UK crypto exchange offering trading, custody and access to money market funds in GBP, USD and EUR. Archax Exchange`;
const DEFAULT_META_KEYWORDS = `Archax, regulated crypto exchange UK, Bitcoin, Ethereum, BTC, ETH, GBP, USD, EUR, buy crypto, sell crypto, digital assets, blockchain, FCA regulated, custody, trade, money market funds`;

const preConfigMetaMap = {
  login: {
    metaDescription: DEFAULT_META_DESCRIPTION,
    metaKeywords: DEFAULT_META_KEYWORDS,
  },
  register: {
    metaDescription: DEFAULT_META_DESCRIPTION,
    metaKeywords: DEFAULT_META_KEYWORDS,
  },
};

export const Seo: FC<SeoProps> = ({
  title = "Archax Exchange",
  preConfig,
  metaDescription,
  metaKeywords,
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      {preConfig && preConfigMetaMap[preConfig] && (
        <>
          <meta
            name="description"
            content={
              metaDescription ||
              preConfigMetaMap[preConfig].metaDescription ||
              ""
            }
          />
          <meta
            name="keywords"
            content={
              metaKeywords || preConfigMetaMap[preConfig].metaKeywords || ""
            }
          />
        </>
      )}
      {!preConfig && metaDescription && (
        <meta name="description" content={metaDescription} />
      )}
      {!preConfig && metaKeywords && (
        <meta name="keywords" content={metaKeywords} />
      )}
    </Helmet>
  );
};
